// Pinned fixture values are only for local/demo fallback routes and reset tooling.
export const DEMO_FIXTURE_CLIENT_SLUG = "wiley-gourmet-supermarket";
export const DEMO_FIXTURE_MONTH = "2026-09";
